<!--SKU编辑  -->
<template>
	<div>
		<el-dialog title="用户信息" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="600px" :before-close="cancle"
			v-if="dialogVisible">
			<div class="form-box">
				<el-form label-position="top" size="small" :model="ruleForm" :rules="rules" ref="ruleForm">
					<el-form-item label="角色信息" prop="roleIds">
						<el-checkbox-group v-model="ruleForm.roleIds" @change="handleRole">
							<el-checkbox :label="item.roleId" v-for="item in roleList" :key="item.roleIds"
								:disabled="item.disabled">{{item.roleName}}</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-divider></el-divider>
					<el-form-item label="组织部门" prop="groupIds">
						<div class="flex">
							<el-input v-model.trim="ruleForm.groupName" readonly  :disabled="ruleForm.userId?true:false"></el-input>
							<el-button  size="small" type="primary" class="ml20" @click="showGroupTree"  :disabled="ruleForm.userId?true:false">配置组织</el-button>
						</div>
					</el-form-item>
					<el-divider></el-divider>

					<div class="flex flex-between err-log">
						<el-form-item class="flex" label="账号" prop="userCode" label-width="100px">
							<el-input class="ml27 w190" v-model.trim="ruleForm.userCode" maxlength="16" :disabled="true">
							</el-input>
						</el-form-item>
						<el-form-item class="flex" label="姓名" prop="userName" label-width="100px">
							<el-input class="ml27 w190" v-model.trim="ruleForm.userName" maxlength="10"  :disabled="ruleForm.userId?true:false"></el-input>
						</el-form-item>
					</div>
					<el-form-item class="flex" label="联系电话" prop="userPhone">
						<el-input class="ml10 w190" v-model.trim="ruleForm.userPhone" maxlength="11"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button  size="small" @click="cancle()">取 消</el-button>
				<el-button  size="small" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
			</span>
		</el-dialog>
		<groupTree v-if="groupTreeDialog" ref="groupTree" @groupIdListener="groupIdCallback"
			@groupNameListener="groupNameCallback">
		</groupTree>
	</div>
</template>

<script>
	import groupTree from '@/components/groupTree/index.vue';
	import {
		debounce
	} from '@/utils/debounce'
	export default {
		components: {
			groupTree
		},
		data() {
			return {
				dialogVisible: false,
				groupTreeDialog: false,
				treeData: [],
				ruleForm: {
					userCode: "",
					userName: "",
					userPhone: "",
					groupName: "",
					groupIds: null,
					roleIds: [],
					userId: "",
				},
				rules: {
					userName: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}, ],
					userCode: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}, ],
					groupIds: [{
						required: true,
						message: '请至少选择一个组织',
						trigger: 'change'
					}],
					roleIds: [{
						type: 'array',
						required: true,
						message: '请至少选择一个角色',
						trigger: 'change'
					}],
					userPhone: [{
						pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
						message: '请输入正确联系电话',
						trigger: 'blur'
					}, ],
				},
				roleList: [],
			}
		},
		created() {

		},
		methods: {
			init(tree, data) {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.ruleForm = {
						userCode: "",
						userName: "",
						userPhone: "",
						groupName: "",
						groupIds: null,
						roleIds: [],
						userId: "",
					}
					this.getRoleList()
					this.treeData = tree
					if (data) {
						this.getUserInfo(data.dataKey)
					}
				})


			},
			handleRole(val,type) {
				if(this.ruleForm.userId && type == undefined) {
					return
				}
				if (val.length > 0) {
					this.roleList.forEach(item => {
						// 选择的id
						val.forEach(ele => {
							// 路线 内外勤
							if (ele == 2 || ele == 3) {
								if (item.roleId == 2 || item.roleId == 3) {
									item.disabled = false
								} else {
									item.disabled = true
								}
							} else {
								// 其它
								if (item.roleId == 2 || item.roleId == 3) {
									item.disabled = true
								} else {
									item.disabled = false
								}
							}
						});
					});
				} else {
					this.roleList.forEach(item => {
						item.disabled = false
					})
				}
			},
			//  获取用户角色
			getRoleList() {
				let that = this;
				that.$request.post(
						"roleList",
						true, {}
					)
					.then((res) => {
						if (res) {
							let roleType = window.sessionStorage.getItem("roleType")
							that.roleList = []
							// admin
							if(roleType==0){
								res.data.forEach(item => {
									item.disabled = false
								});
								that.roleList = res.data
							}else{
								// 只能选路线内外勤
								res.data.forEach(item => {
									if(item.roleType<=2){
										item.disabled = false
										that.roleList.push(item)
									}
								});
							}
						} else {
							that.$message.error(res.msg);
						}
					})
			},
			//  查询
			getUserInfo(id) {
				let that = this;
				that.$request.post(
						"userInfo",
						false, {
							userId: id
						}
					)
					.then((res) => {
						if (res) {
							that.ruleForm = {
								userCode: res.data.userCode,
								userName: res.data.userName,
								userPhone: res.data.userPhone,
								groupName: res.data.groupName,
								groupIds: res.data.groupIds,
								roleIds: res.data.roleIds,
								userId: id
							}
							let groupIds = []
							let groupName = []
							let roleIds = []
							res.data.sysGroupUserList.forEach(item => {
								groupIds.push(item.groupId)
								groupName.push(item.groupName)
							});
							res.data.sysUserRoleList.forEach(item => {
								roleIds.push(item.roleId)
							});
							that.ruleForm.groupName = groupName.join(",")
							that.ruleForm.groupIds = groupIds
							that.ruleForm.roleIds = roleIds
							that.handleRole(roleIds,true)
						} else {
							that.$message.error(res.msg);
						}
					})
			},
			// 组织树
			showGroupTree() {
				this.groupTreeDialog = true;
				this.$nextTick(() => {
					this.$refs.groupTree.init(this.treeData, this.ruleForm.groupIds);
				});
			},
			// 保存
			submitForm: debounce(function () {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.$confirm('是否确认保存？', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
						}).then(() => {
						if (!this.ruleForm.userId) {
							this.addRow()
						} else {
							this.updateRow()
						}
						}).catch(() => {});
					} else {
						return false;
					}
				});
			}, 1000, true),
			// groupId回调
			groupIdCallback(val) {
				this.ruleForm.groupIds = val
				if (!this.ruleForm.userId) {
					this.getAutoUserCode()
				}
			},
			// 自动获取用户编码
			getAutoUserCode() {
				let that = this;
				that.$request.post(
					"autoUserCode",
					false, {
						groupId: that.ruleForm.groupIds,
					}
				)
				.then((res) => {
					if (res) {
						that.ruleForm.userCode = res.data
					}
				})
			},
			// groupName回调
			groupNameCallback(val) {
				this.ruleForm.groupName = val
			},
			// 新增
			addRow() {
				let that = this;
				that.$request.post(
					"userAdd",
					true, {
						groupIds: [that.ruleForm.groupIds],
						roleIds: that.ruleForm.roleIds,
						userCode: that.ruleForm.userCode,
						userName: that.ruleForm.userName,
						userPhone: that.ruleForm.userPhone
					}
				)
				.then((res) => {
					if (res) {
						that.dialogVisible = false
						that.$message.success("保存成功！");
						that.$emit("getList")
					}

				})
			},
			// 修改
			updateRow() {
				let that = this;
				that.$request.post(
						"userUpdate",
						false, {
							userId: that.ruleForm.userId,
							groupIds: typeof that.ruleForm.groupIds == 'number' ? [that.ruleForm.groupIds] : that.ruleForm.groupIds,
							roleIds: that.ruleForm.roleIds,
							userCode: that.ruleForm.userCode,
							userName: that.ruleForm.userName,
							userPhone: that.ruleForm.userPhone,
						}
					)
					.then((res) => {
						if (res) {
							that.dialogVisible = false
							that.$message.success("保存成功！");
							that.$emit("getList")
						}
					})
			},
			// 取消
			cancle() {
				this.dialogVisible = false
				this.$refs['ruleForm'].resetFields();
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.mb0 {
		margin-bottom: 0 !important;
	}

	.ml27 {
		margin-left: 28px;
	}

	.err-log {
		/deep/ .el-form-item__error {
			left: 27px;
		}
	}

</style>
